import React from "react";

const MyBuyers = () => {
  return (
    <div>
      <h1>my buyers</h1>
    </div>
  );
};

export default MyBuyers;
